<script>
    import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();
	const goBack = () => {
		dispatch('go', '');
	}
    const today = new Date();
    const copyright = `${today.getFullYear() > 2021 ? `2021-${today.getFullYear()}` : `2021`} Tom Kulick and College Guidance Services of Texas.`;
</script>

<header class='bg-white pa3 ph4-ns ph5-l ph5-xl tc tl-ns flex-ns items-center justify-between'>
    <h1 class='f3 ma0 pa0 garamond ttu tracked fw4 black-70 mb3 mb0-ns'>Tom Kulick</h1>
    <h2 class='f5 f4-ns ma0 pa0 garamond ttu tracked fw4'>College Guidance Services of Texas</h2>
</header>
<div class='tc pt5'>
    <button on:click={goBack} class='dib blue dim hover mb3 pointer bg-transparent bn'>Go Back</button>
    <iframe class='db center w-100' title="Worksheet for Potential Students" src="https://docs.google.com/forms/d/e/1FAIpQLSfoG_ajOv5vk0mg7OmmHR1qmrnZeqa6lqh97ujXE5IngfuQqQ/viewform?embedded=true" height="6772" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
</div>
<footer class='tc bt b--black-05 pa2'>
    <p class='f6 lato lh-copy'>&copy; {copyright}</p>
</footer>